import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import BoShowAttachmentGallery from "./bo-show-attachment-gallery.jsx";

const BoShowCroqui = () => {
    const {boData, verifySyncUrl, printOptions} = useContext(BoShowContext);
    const croqui = boData?.croqui;

    if (!croqui?.observation && !croqui?.attachs?.length) return null;

    return (
        <article className={"space-y-4" + (!printOptions.image ? " print:hidden" : "")}>
            <h2 className={"resume-title"}>CROQUI E FOTOS</h2>

            {
                croqui?.observation &&
                <p className={"info whitespace-pre-wrap"}>{croqui.observation}</p>
            }

            {
                !!croqui?.attachs?.length &&
                <BoShowAttachmentGallery
                    attachments={croqui.attachs}
                    verifySyncUrl={verifySyncUrl}
                    titleMaker={(attachment) => `CROQUI E FOTOS - ${attachment?.description ?? ""}`}
                />
            }
        </article>
    );
};

export default BoShowCroqui;
